// @flow

import React from "react";
import { localize } from "redux-i18n";
import Ajv from "ajv";

import actionCreators from "@modules/service/actionCreator";
import { Button } from "@components";
import type { StepProps } from "@components";
import type { AbsenceReason } from "@modules/shared/reducer/absence-reasons/types";
import { EmailNotificationReasonSpecificInstructions as EmailNotificationReasonSpecificInstructionsForm } from "@modules/service/components";

type OwnProps = $Exact<{
  editing: boolean,
  schema: Object,
  edited: Object,
  reasons: Array<AbsenceReason>,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...StepProps,
  ...PropsFromLocalize,
}>;

export class Step2Reaons extends React.Component<Props> {
  validate: *;

  componentDidMount() {
    this.validate = new Ajv().compile(this.schema);
  }

  get data() {
    return this.props.edited;
  }

  get schema() {
    return ((this.props.schema || {}).properties || {}).reasonSpecificInstructions.items;
  }

  isValid = (data?: Object) => {
    const instructions = (data || {}).reasonSpecificInstructions || [];
    if (!this.validate) {
      return false;
    }

    return !instructions.some(rule => !this.validate(rule));
  };

  handleSubmit = () => {
    if (this.props.handleSubmit) {
      this.props.handleSubmit(this.data, true);
    }
  };

  handleChange = (formData: Object) => {
    this.props.onChange(formData, true);
  };

  render() {
    if (!this.props.editable) {
      return <div />;
    }

    return (
      <React.Fragment>
        <div className="w-100 d-flex justify-content-center">
          {this.schema && this.data ? (
            <EmailNotificationReasonSpecificInstructionsForm
              data={this.data}
              schema={this.schema}
              onChange={this.handleChange}
              reasons={this.props.reasons}
              editing
            />
          ) : null}
        </div>
        {this.props.editing ? null : (
          <div className="w-100 d-flex justify-content-end mt-5 mb-3">
            <Button
              materialIcon="fast_forward"
              onClick={this.handleSubmit}
              disabled={!this.isValid(this.data)}
            >
              {this.props.t("NEXT")}
            </Button>
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default localize()(Step2Reaons);
